<template>
    <div v-if="isVisible" class="fixed inset-0 z-50 flex items-center justify-center bg-black backdrop-blur-md bg-opacity-30">
      <div class="bg-white rounded-lg p-8 w-[90%] max-w-md text-center shadow-lg">
        <h2 class="mb-4 text-xl font-bold">{{ title }}</h2>
        <p class="mb-6 text-gray-700">{{ message }}</p>
        <div class="flex justify-center gap-4">
          <button @click="onConfirm"
            class="px-4 py-2 font-semibold text-white bg-green-500 rounded hover:bg-green-600">
            {{ confirmText }}
          </button>
          <button @click="onCancel"
            class="px-4 py-2 font-semibold text-white bg-red-500 rounded hover:bg-red-600">
            {{ cancelText }}
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      title: { type: String, required: true },
      message: { type: String, required: true },
      confirmText: { type: String, default: "Yes" },
      cancelText: { type: String, default: "No" },
      isVisible: { type: Boolean, default: false },
    },
    emits: ["confirm", "cancel"],
    methods: {
      onConfirm() {
        this.$emit("confirm");
      },
      onCancel() {
        this.$emit("cancel");
      },
    },
  };
  </script>
  
  <style scoped>
  button {
    transition: background-color 0.3s ease;
  }
  </style>
  